// src/components/NotFound.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Search } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-6xl text-gray-300">404</h1>
        </div>
        <h2 className="text-2xl text-gray-900 mb-4">Page not found</h2>
        <p className="text-gray-600 mb-8 max-w-md">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="space-x-4">
          <button
            onClick={() => navigate('/')}
            className="bg-electric-blue text-white px-6 py-2  hover:bg-electric-blue-eb3 flex items-center space-x-2 inline-flex"
          >
            <Home className="h-4 w-4" />
            <span>Go Home</span>
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="border border-gray-300 text-gray-700 px-6 py-2  hover:bg-gray-50 flex items-center space-x-2 inline-flex"
          >
            <Search className="h-4 w-4" />
            <span>View Reports</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
